// extracted by mini-css-extract-plugin
export var contentBody = "_c1-9";
export var headerImage = "_c1-2";
export var imageButton = "_c1-7";
export var imageButtonIcon = "_c1-8";
export var imageHeader = "_c1-4";
export var imageHeaderText = "_c1-5";
export var imageOverlay = "_c1-3";
export var imageTitle = "_c1-6";
export var imageWrapper = "_c1-1";
export var taskList = "_c1-a";
export var widget = "_c1-0";